<template>
  <div>
    <label class="text-primary text-sans font-bold text-lg"
      >Search for your business</label
    >
    <div class="flex items-center border-2 rounded border-primary">
      <gmap-autocomplete
        ref="map"
        class="block rounded-lg w-full py-3 px-3 mx-1 focus:outline-none text-gray-700"
        @place_changed="setPlace"
        :types="['establishment']"
      >
      </gmap-autocomplete>
    </div>
  </div>
</template>

<script>
import gmapAutocomplete from "vue2-google-maps/src/components/autocomplete";
export default {
  components: { gmapAutocomplete },
  name: "GoogleMap",
  props: ["value"],
  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.$emit("input", place);
    },
  }
};
</script>
